import { SimplexNoise } from "three/addons/math/SimplexNoise.js";

export function mulberry32(seed) {
    let a = seed >>> 0;
    return function random() {
        a = (a + 0x6d2b79f5) | 0;
        let t = Math.imul(a ^ (a >>> 15), 1 | a);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}

export function createNoise(seed) {
    const simplex = new SimplexNoise({ random: mulberry32(seed) });

    return {
        noise2(x, y) {
            return simplex.noise(x, y);
        },

        fbm(x, y, octaves) {
            let value = 0;
            let amplitude = 1;
            let sum = 0;
            let frequency = 1;
            for (let octave = 0; octave < octaves; octave++) {
                value += simplex.noise(x * frequency, y * frequency) * amplitude;
                sum += amplitude;
                amplitude *= 0.5;
                frequency *= 2;
            }
            return sum > 0 ? value / sum : 0;
        },
    };
}
